import axios from "axios";

export const getApiBaseUrl = () => {
  let envUrl = process.env.REACT_APP_BACKEND_URL;
  if (envUrl) {
    envUrl = envUrl.replace(/\/+$/, "");
    return envUrl.endsWith("/api") ? envUrl : `${envUrl}/api`;
  }
  if (
    typeof window !== "undefined" &&
    (window.location.hostname === "localhost" ||
      window.location.hostname === "127.0.0.1" ||
      window.location.hostname === "[::1]")
  ) {
    return "http://localhost:8000/api";
  }
  return "/api";
};

export const API_BASE = getApiBaseUrl();

const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
});

// Attach Bearer token fallback (in case cookies are stripped by some proxies)
api.interceptors.request.use((config) => {
  const t = localStorage.getItem("studlyf_session_token");
  if (t) {
    config.headers = config.headers || {};
    if (typeof config.headers.set === "function") {
      config.headers.set("Authorization", `Bearer ${t}`);
    } else {
      config.headers.Authorization = `Bearer ${t}`;
      config.headers["Authorization"] = `Bearer ${t}`;
    }
  }
  return config;
});

export default api;
